export default async function getLocales(company, language = "pt-br") {
  const folder = company === "tok_stok" ? "B" : "A";
  const values = await import(`./${folder}/${language}.json`);
  return values;
}
